import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { listenToUserCart } from "./functionFirebase";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    let unsubscribeCart;
    const unsubscribeAuth = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        // استمع للسلة من Firestore
        unsubscribeCart = listenToUserCart(firebaseUser.uid, (result) => {
          const newCart = result.success ? result.cart : [];
          setCart(newCart);
          setCartCount(Array.isArray(newCart) ? newCart.reduce((sum, item) => sum + item.quantity, 0) : 0);
        });
      } else {
        // للزوار: استخدم localStorage
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCart(localCart);
        setCartCount(localCart.reduce((sum, item) => sum + item.quantity, 0));
        // استمع لتغييرات localStorage
        const handleStorage = () => {
          const updatedCart = JSON.parse(localStorage.getItem("cart")) || [];
          setCart(updatedCart);
          setCartCount(updatedCart.reduce((sum, item) => sum + item.quantity, 0));
        };
        window.addEventListener("storage", handleStorage);
        unsubscribeCart = () => window.removeEventListener("storage", handleStorage);
      }
    });
    return () => {
      if (unsubscribeCart) unsubscribeCart();
      unsubscribeAuth();
    };
  }, []);

  // دالة لتحديث العداد يدويًا (للتوافق)
  const refreshCartCount = async () => {
    setCartCount(Array.isArray(cart) ? cart.reduce((sum, item) => sum + item.quantity, 0) : 0);
  };

  return (
    <CartContext.Provider value={{ cart, setCart, cartCount, setCartCount, refreshCartCount, user }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
} 